<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_193_10323)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_193_10323)" />
    </g>
    <path
      d="M17 23.8333C16.8679 23.8316 16.7418 23.7784 16.6484 23.685C16.555 23.5916 16.5017 23.4654 16.5 23.3333V12.6667C16.5 12.5341 16.5527 12.4069 16.6464 12.3131C16.7402 12.2194 16.8674 12.1667 17 12.1667C17.1326 12.1667 17.2598 12.2194 17.3536 12.3131C17.4473 12.4069 17.5 12.5341 17.5 12.6667V23.3333C17.4983 23.4654 17.445 23.5916 17.3516 23.685C17.2582 23.7784 17.1321 23.8316 17 23.8333Z"
      fill="white" />
    <path
      d="M17.9998 22.5H13.6665C13.5339 22.5 13.4067 22.4473 13.313 22.3536C13.2192 22.2598 13.1665 22.1326 13.1665 22C13.1665 21.8674 13.2192 21.7402 13.313 21.6464C13.4067 21.5527 13.5339 21.5 13.6665 21.5H17.9998C18.4409 21.5393 18.8797 21.4043 19.2224 21.1239C19.5651 20.8435 19.7844 20.4401 19.8332 20C19.7844 19.5599 19.5651 19.1565 19.2224 18.8761C18.8797 18.5957 18.4409 18.4607 17.9998 18.5H15.9998C15.6495 18.5226 15.2981 18.4758 14.9659 18.3622C14.6337 18.2487 14.3272 18.0707 14.064 17.8384C13.8007 17.6061 13.5859 17.3242 13.4319 17.0087C13.2779 16.6932 13.1877 16.3504 13.1665 16C13.1877 15.6496 13.2779 15.3068 13.4319 14.9913C13.5859 14.6758 13.8007 14.3938 14.064 14.1616C14.3272 13.9293 14.6337 13.7513 14.9659 13.6378C15.2981 13.5242 15.6495 13.4774 15.9998 13.5H19.6665C19.7991 13.5 19.9263 13.5527 20.0201 13.6464C20.1138 13.7402 20.1665 13.8674 20.1665 14C20.1665 14.1326 20.1138 14.2598 20.0201 14.3536C19.9263 14.4473 19.7991 14.5 19.6665 14.5H15.9998C15.5588 14.4607 15.1199 14.5957 14.7772 14.8761C14.4345 15.1565 14.2153 15.5599 14.1665 16C14.2153 16.4401 14.4345 16.8435 14.7772 17.1239C15.1199 17.4043 15.5588 17.5393 15.9998 17.5H17.9998C18.3502 17.4774 18.7015 17.5242 19.0337 17.6378C19.3659 17.7513 19.6725 17.9293 19.9357 18.1616C20.1989 18.3938 20.4137 18.6758 20.5677 18.9913C20.7218 19.3068 20.812 19.6496 20.8332 20C20.812 20.3504 20.7218 20.6932 20.5677 21.0087C20.4137 21.3242 20.1989 21.6061 19.9357 21.8384C19.6725 22.0707 19.3659 22.2487 19.0337 22.3622C18.7015 22.4758 18.3502 22.5226 17.9998 22.5Z"
      fill="white" />
    <defs>
      <filter id="filter0_d_193_10323"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.268632 0 0 0 0 0.841667 0 0 0 0 0.175347 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_193_10323" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_193_10323" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_193_10323"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#27C884" />
        <stop offset="1" stop-color="#45D72D" />
      </linearGradient>
    </defs>
  </svg>
</template>
